var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var Twitter = function (props) { return (_jsx("svg", __assign({}, props, { width: "16", height: "16", viewBox: "0 0 10 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M5.95136 4.23432L9.67408 0H8.79192L5.55948 3.6766L2.97773 0H0L3.9041 5.55967L0 10H0.882217L4.29576 6.11739L7.02227 10H10L5.95114 4.23432H5.95136ZM4.74304 5.60865L4.34748 5.05503L1.20009 0.64984H2.55512L5.0951 4.20497L5.49067 4.75859L8.79233 9.37971H7.4373L4.74304 5.60886V5.60865Z", fill: "white" }) }))); };
export default Twitter;
//# sourceMappingURL=twitter.js.map